export default __webpack_public_path__ + "static/media/user.ba066518.webp";